<template>
  <Table :properties="tableProperties">
    <template v-slot:searchFields="" >
      <v-col cols="12" class="pb-0">
        <v-text-field
            hide-details
            clearable
            outlined
            reverse
            dense
            :label=           "$t('field.SERNUM')"
            :rules=           "rules"
            v-model=          "serialNumber"
            :disabled=        "tableProperties.loading"
            @keypress.enter=  "getData"
        />
      </v-col>
    </template>
  </Table>
</template>
<script>
  import { API }  from 'aws-amplify'
  import Table    from '../components/Table'

  export default {
    name:       'Parts2',
    components: { Table },
    data() {
      return {
        rules: [ value => !value || this.validateInput() ],
        serialNumber: '',
        tableProperties: {
          items:        [],
          sortBy:       ['YHV_FDATE'],
          sortDir:      [true],
          loading:      false,
          getData:      this.getData,
          itemsPerPage: 100,
          submitBtn:    { disabled: true },
          headers: [
            { text: this.$t('field.YHV_TEXT'),  value: 'YHV_TEXT'  },
            { text: this.$t('field.YHV_FDATE'), value: 'YHV_FDATE' }
          ]
        }
      }
    },
    methods: {
      validateInput() {
        let valid = !!(this.serialNumber || '').match(/^\d+$/)
        this.tableProperties.submitBtn.disabled = !valid
        return valid
      },
      getData() {
        if (!this.validateInput()) return

        this.items                    = []
        this.tableProperties.loading  = true
        API.get('priority', `/apiv1/notes?SERNUM=${this.serialNumber}`, null)
            .then(res => this.tableProperties.items = res)
            .finally(() => this.tableProperties.loading = false)
      }
    }
  }
</script>
